import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DreamErrorType } from '../../../features/dream';

export const ErrorText: React.FC<{ errorType: DreamErrorType }> = ({ errorType }) => {
  const { t } = useTranslation('translation');
  let text: string;
  switch (errorType) {
    case 'unstable-network':
      text = t('error_unstable_network');
      break;
    case 'loading-failed':
    case 'unknown':
    default:
      text = t('error_unknown');
  }
  return (
    <p
      className={css`
        font-size: 12px;
        text-align: center;
        color: #e60012;
        margin: 8px 0;
      `}
    >
      {text}
    </p>
  );
};
